"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Aug 22 2018
 */

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

exports.SPECIAL_ID_COMPOUND_ID_PREFIX = 'specialId-';
exports.EAN_COMPOUND_ID_PREFIX = 'ean-';
exports.EXTERNAL_ID_COMPOUND_ID_PREFIX = 'externalId-';
/**
 * Class represents competitor product for data-pairing
 *
 * @author RV
 */

var CompetitorProduct =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompetitorProduct, _DomainObject_1$Domai);

  /**
   *
   * @param id
   * @param eans unique strings for pairing internal and competitor's products
   * @param name
   * @param productSize
   * @param productSizeUnit type of unit (kg ...)
   * @param category of product
   * @param productContent the content of the product (e.g. 95% meat)
   * @param productSpecification detailed specification of the product
   * @param suppliers
   * @param ignored
   * @param competitorId
   * @param competitorExternalId this ID we need for checking unique pairs competitor-product in raw data
   * @param externalId
   * @param specialId
   * @param available a flag telling if the product is currently available at the competitor's store
   * @param comment comment from the field researcher on the product
   * @param compoundId all product identifiers (eans, externalId, specialId), serving for unique competitor product identification
   * Every identifier type has a specific prefix to distinguish among them.
   * @param internalCategoryIds IDs of categories of paired internal product, it remains even after the pair is canceled
   */
  function CompetitorProduct(id, eans, name, productSize, productSizeUnit, category, productContent, productSpecification) {
    var _this;

    var suppliers = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : immutable_1.List();
    var ignored = arguments.length > 9 ? arguments[9] : undefined;
    var competitorId = arguments.length > 10 ? arguments[10] : undefined;
    var competitorExternalId = arguments.length > 11 ? arguments[11] : undefined;
    var externalId = arguments.length > 12 ? arguments[12] : undefined;
    var specialId = arguments.length > 13 ? arguments[13] : undefined;
    var available = arguments.length > 14 ? arguments[14] : undefined;
    var comment = arguments.length > 15 ? arguments[15] : undefined;
    var compoundId = arguments.length > 16 ? arguments[16] : undefined;
    var internalCategoryIds = arguments.length > 17 ? arguments[17] : undefined;

    _classCallCheck(this, CompetitorProduct);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProduct).call(this));
    _this.id = id;
    _this.eans = eans;
    _this.name = name;
    _this.productSize = productSize;
    _this.productSizeUnit = productSizeUnit;
    _this.category = category;
    _this.productContent = productContent;
    _this.productSpecification = productSpecification;
    _this.suppliers = suppliers;
    _this.ignored = ignored;
    _this.competitorId = competitorId;
    _this.competitorExternalId = competitorExternalId;
    _this.externalId = externalId;
    _this.specialId = specialId;
    _this.available = available;
    _this.comment = comment;
    _this.compoundId = compoundId;
    _this.internalCategoryIds = internalCategoryIds;
    return _this;
  }
  /**
   * Constructs a compound ID from various competitor product identifiers.
   * The compound ID is a list of the identifiers with type specific prefixes. It is used for seme products identification.
   */


  _createClass(CompetitorProduct, null, [{
    key: "constructCompoundId",
    value: function constructCompoundId(eans, specialId, externalId) {
      var compoundId = eans.reduce(function (result, ean) {
        return result.push(exports.EAN_COMPOUND_ID_PREFIX + ean.value);
      }, immutable_1.List());

      if (externalId) {
        compoundId = compoundId.push(exports.EXTERNAL_ID_COMPOUND_ID_PREFIX + externalId);
      }

      if (specialId) {
        compoundId = compoundId.push(exports.SPECIAL_ID_COMPOUND_ID_PREFIX + specialId);
      }

      return compoundId;
    }
  }]);

  return CompetitorProduct;
}(DomainObject_1.DomainObject);

exports.CompetitorProduct = CompetitorProduct; // tslint:disable-next-line:member-ordering

CompetitorProduct.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompetitorProduct.name);
  return {
    id: builder.id('id'),
    eans: builder.listOf(builder.data('ean', {
      value: builder.str('value'),
      dateFrom: builder.opt(builder.date('dateFrom')),
      dateTo: builder.opt(builder.date('dateTo')),
      active: builder.opt(builder.bool('active')),
      eanDescription: builder.opt(builder.str('eanDescription'))
    })),
    name: builder.str('name'),
    productSize: builder.opt(builder.num('productSize')),
    productSizeUnit: builder.opt(builder.str('productSizeUnit')),
    category: builder.opt(builder.str('category')),
    productContent: builder.opt(builder.str('productContent')),
    productSpecification: builder.opt(builder.str('productSpecification')),
    suppliers: builder.listOf(builder.str('suppliers')),
    ignored: builder.bool('ignored'),
    competitorId: builder.str('competitorId'),
    competitorExternalId: builder.str('competitorExternalId'),
    externalId: builder.opt(builder.str('externalId')),
    specialId: builder.opt(builder.str('specialId')),
    available: builder.opt(builder.bool('available')),
    comment: builder.opt(builder.str('comment')),
    compoundId: builder.listOf(builder.str('compoundId')),
    internalCategoryIds: builder.opt(builder.listOf(builder.str('internalCategoryIds')))
  };
}();